import React from 'react';
import PropTypes from 'prop-types';
import { AtomicText } from './Text';

const defaultStyles = {
  mobile: {
    font: `400 15px/17px 'CentraNo2', sans-serif`,
    'letter-spacing': '0.28px',
    color: '#777777',
    margin: 0
  },
  tablet: {},
  desktop: {}
};

const xlStyles = {
  mobile: {
    'font-size': '17px',
    'letter-spacing': '0.281px',
    'line-height': '20px',
    'font-family': `'CentraNo2', sans-serif`,
    'font-weight': '400',
    color: '#777777',
    margin: 0
  },
  tablet: {
    'font-size': '17px'
  },
  desktop: {}
};

const DescriptionText = ({ text, className, xl, truncateLines }) => (
  <AtomicText
    element="p"
    tabletDesign={xl ? xlStyles.tablet : defaultStyles.tablet}
    mobileDesign={xl ? xlStyles.mobile : defaultStyles.mobile}
    desktopDesign={xl ? xlStyles.desktop : defaultStyles.desktopDesign}
    className={className}
    truncateLines={truncateLines}
  >
    {text}
  </AtomicText>
);

DescriptionText.defaultProps = {
  className: undefined,
  xl: undefined,
  truncateLines: undefined
};

DescriptionText.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  xl: PropTypes.bool,
  truncateLines: PropTypes.number
};

export default DescriptionText;
